// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: "Roboto-Regular"
    },
    palette: {
        action: {
            disabled: 'rgba(0, 0, 0, 0.38)',
            disabledBackground: '#f2f2f2',
        }
    },
    components: {
        MuiTableSortLabel: {
            styleOverrides: {
                root: ({ ownerState, theme }) => ({
                    color: theme.palette.text.secondary,
                    fontFamily: "Roboto-Regular",
                    '&:hover': {
                        color: '#000'
                    },
                    '&.Mui-active': {
                        color: '#496ac5',
                        fontWeight: 'bold',
                        '&:hover': {
                            color: '#496ac5',
                        },
                        '& .MuiTableSortLabel-icon': {
                            color: ' #496AC9',
                            opacity: 1
                        },
                    },
                    '& .MuiTableSortLabel-icon': {
                        opacity: 0.5,
                        color: '#000'
                    }
                }),
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    marginTop: '0px',
                    marginBottom: '0px',
                    fontFamily: "Roboto-Regular"
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        backgroundColor: '#f2f2f2',
                        cursor: 'not-allowed',
                    }
                },
                input: {
                    fontFamily: "Roboto-Regular",
                    '&.Mui-disabled': {
                        WebkitTextFillColor: 'rgba(0, 0, 0, 0.38)',
                        backgroundColor: '#f2f2f2',
                        cursor: 'not-allowed',
                    },
                },
                inputMultiline: {
                    fontFamily: "Roboto-Regular",
                    '&.Mui-disabled': {
                        backgroundColor: '#f2f2f2',
                    }
                }
            },
        },
        // MuiRadio: {
        //     styleOverrides: {
        //         root: {
        //             color: '#3c3c3c',
        //             fontFamily: "Roboto-Regular",
        //             '&.Mui-checked': {
        //                 color: '#3c3c3c',
        //             },
        //         },
        //     },
        // },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    fontSize: '13px',
                    fontFamily: "Roboto-Regular",
                },
                root: {
                    fontFamily: "Roboto-Regular",
                    '&.Mui-disabled': {
                        cursor: 'not-allowed',
                        opacity: 1
                    }
                }
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontFamily: "Roboto-Regular",
                    '&.Mui-disabled': {
                        color: 'rgba(0, 0, 0, 0.38)',
                    }
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: "Roboto-Regular"
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                inputRoot: {
                    fontFamily: "Roboto-Regular",
                    '&.Mui-disabled': {
                        backgroundColor: '#f2f2f2',
                        color: 'rgba(0, 0, 0, 0.38)',
                        cursor: 'not-allowed',
                    }
                },
                option: {
                    fontFamily: "Roboto-Regular"
                },
            }
        }
    }
});

export default theme;
